// extracted by mini-css-extract-plugin
module.exports = {"main":"Footer_main__14-SF","logo":"Footer_logo__2RVT_"};